import React,{Component} from "react";
import './contact.css';
import axios from 'axios';
import Captcha from 'react-captcha';

function replacer(key, value) {
    if (key === "age") {
      return value + ' years';
    }
    return value;
}//end replacer

class Contactform extends React.Component{
    constructor(){
        super();
        this.state={
            data:{
                name:'',
                message:'',
                phonenumber:'',
                email:'',
            },
            validation:{
                email:false,
                message:false,
                name:false,
            },
            showSuccess:false,
            robotVerification:false,
            showRobotWarning:false,
            emailWrongFormat:false,
            notanumber:false,
        }
    }
    handleChange(e){
        let data = this.state.data;
        if(e.target.id==="phonenumber"){
          if(isNaN(e.target.value)){
            this.setState({notanumber:true});
          }else{
            this.setState({notanumber:false});
            data[e.target.id]=e.target.value;
            this.setState({data:data,showSuccess:false,validation:{email:false,message:false,name:false,emailWrongFormat:false}});
          }
        }else{
          data[e.target.id]=e.target.value;
          this.setState({data:data,showSuccess:false,validation:{email:false,message:false,name:false,emailWrongFormat:false}});
        }

    }
    sendDataGoogle(){
        let current = this;
        let data = this.state.data;
        let reset={
            name:'',
            message:'',
            phonenumber:'',
            email:'',
        }
        let validation = this.state.validation;
        let validationstatus=false;
        for(let key in data){
            if(data[key]==="" && key!="phonenumber"){
                  validation[key] = true;
                  validationstatus = true;
            }else{
              if(key==="email"){
                let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                 if(!re.test(data.email)){
                   this.setState({emailWrongFormat:true});
                   validationstatus = true;
                 }else{
                   this.setState({emailWrongFormat:false})
                 }
              }
            }

        }
        this.setState({validation:validation,showSuccess:false});
        if(this.state.robotVerification===false){
            this.setState({showRobotWarning:true});
        }else{
            this.setState({showRobotWarning:false});
        }

        if(validationstatus===false && this.state.robotVerification===true){
          let bodyFormData = new FormData();
          bodyFormData.set('name', data.name);
          bodyFormData.set('email', data.email);
          bodyFormData.set('message', data.message);
          bodyFormData.set('phone', data.phonenumber);
            axios.post('/contact.php', bodyFormData)
            .then(function (response) {
                current.setState({showSuccess:true,data:reset,validation:{email:false,message:false,name:false},robotVerification:false});
                grecaptcha.reset();
            })
            .catch(function (error) {
                console.log(error);
            });
        }


    }
    checkingRobot(data){
        if(data!==""){
            this.setState({robotVerification:true,showRobotWarning:false});
        }
    }
    render(){
        return(
            <span>

        <div className="Contactus-form">
            <div className="contact_row">
                <span className="name_icon icon"></span>
                <span className="form-tags">Your name :</span>
                <input type="text"  id="name" value={this.state.data.name} onChange={this.handleChange.bind(this)} className="form-input user-background" />
                {this.state.validation.name && <span className="error_msg">* Mandatory field</span>}
            </div>
            <div className="contact_row" style={{height:"60px"}}>
                <div className="row_devider email" style={{paddingRight:"15px"}}>
                    <span className="email_icon icon"></span>
                    <span className="form-tags">Your email :</span>
                    <input type="text" id="email" value={this.state.data.email} onChange={this.handleChange.bind(this)} className="form-input email-background"  />
                    {this.state.validation.email && <span className="error_msg">* Mandatory field</span>}
                    {this.state.emailWrongFormat && <span className="error_msg">* Please enter a valid email</span>}
                </div>
                <div className="row_devider">
                <span className="phone_icon icon"></span>
                    <span className="form-tags">Your Phone number</span>
                    <input type="text"  id="phonenumber" value={this.state.data.phonenumber}  onChange={this.handleChange.bind(this)} className="form-input phone-background"/>
                    {this.state.notanumber && <span className="error_msg">* Input only numbers</span>}
                </div>
            </div>
            <div className="contact_row">
                <span className="message_icon icon"></span>
                <span className="form-tags">Message </span>
                <textarea id="message" value={this.state.data.message}  onChange={this.handleChange.bind(this)} className="form-input"></textarea>
                {this.state.validation.message && <span className="error_msg">* Mandatory field</span>}
            </div>
            <div className="contact_row">
                <Captcha
                    sitekey = '6Lf3Jk4UAAAAAFuv-TAo37y6PizGX7gE8nqMAsMG'
                    lang = 'en'
                    theme = 'light'
                    type = 'image'
                    callback = {this.checkingRobot.bind(this)}/>
            </div>
            {this.state.showRobotWarning===true && <span className="error_msg">* please check the captcha box to submit your form</span>}
            <button className="submit_button" onClick={this.sendDataGoogle.bind(this)}>SEND</button>
            {this.state.showSuccess && <span>Your message was sent</span>}
        </div>

    </span>
        )
    }
}
export default Contactform;



// WEBPACK FOOTER //
// ./src/components/contactusForm/contactusForm.js